import { ReactElement, useState } from 'react';
import { Button, Modal } from 'antd';
import styles from './ConnectionAssistant.module.less';
import { ApiOutlined } from '@severalnines/frontend_hub/libs/icons';
import ConnectionAssistantForm from './ConnectionAssistantForm';
import DbDatabase from '../../types/DbDatabase';
import CcxComponentProps from '../../core/CcxComponent';
import { Row } from 'antd';
import { Col } from 'antd';
import DeploymentsItem from '../../types/DeploymentsItem';
interface Props extends CcxComponentProps {
    databases?: DbDatabase[];
    users?: string[];
    hosts?: any;
    service?: string;
    disabled?: boolean;
    datastore?: DeploymentsItem | undefined;
}

function ConnectionAssistant({
    databases,
    users,
    hosts,
    service,
    datastore,
    disabled = false,
    testId = 'ConnectionAssistant',
}: Props): ReactElement {
    const [connectionStringsVisible, setConnectionStringsVisible] =
        useState(false);

    const hide = () => {
        setConnectionStringsVisible(false);
    };

    const show = () => {
        if (disabled) return;

        setConnectionStringsVisible(true);
    };

    return (
        <div className={styles.ConnectionAssistant} data-testid={testId}>
            <Button
                disabled={disabled}
                data-testid={`${testId}Button`}
                onClick={show}
                className={styles.ConnectionAssistantButton}
            >
                <ApiOutlined data-testid={`${testId}ButtonIcon`} />
                <span className={styles.ConnectionAssistantText}>
                    Connection assistant
                </span>
            </Button>

            <Modal
                title={'Connection assistant'}
                open={connectionStringsVisible}
                data-testid={`${testId}Modal`}
                width={850}
                onCancel={hide}
                footer={
                    <Row justify="end">
                        <Col className={styles.ButtonDrawerFormButtonRight}>
                            <Button
                                data-testid={`${testId}SubmitButton`}
                                onClick={hide}
                            >
                                Close
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <ConnectionAssistantForm
                    testId={`${testId}ModalForm`}
                    databases={databases}
                    users={users}
                    hosts={hosts}
                    service={service}
                    dataStore={datastore}
                />
            </Modal>
        </div>
    );
}

export default ConnectionAssistant;
